module.exports = function(app) {
	app.run(['Service','sessionData', function (Service, sessionData) {
		return new Service({

			name: 'coverages',
			group: 'eprsvc',
			url: '/eprsvc/x-services/secure/coverages/:version/:coverageType/:effectiveDate/:zipCode',
			cache: false,

			fetch: function() {
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.get();
			}
		});
	}]);
};
